if (!customElements.get("product-recommendations")) {
  customElements.define(
    "product-recommendations",
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              let html = generateDomFromString(text);
              let recommendations = html.querySelector("product-recommendations");

              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
                __reInitTooltip(this);
                this.setProductCardLoad(html);
              } else if (typeof this.dataset.fallbackUrl === "string") {
                fetch(this.dataset.fallbackUrl)
                  .then((response) => response.text())
                  .then((text) => {
                    let html = generateDomFromString(text);
                    let recommendations = html.querySelector("product-recommendations");

                    if (recommendations && recommendations.innerHTML.trim().length) {
                      this.innerHTML = recommendations.innerHTML;
                      __reInitTooltip(this);
                    }
                    this.setProductCardLoad(html);
                  })
                  .catch((e) => {
                    console.error(e);
                  });
              } else {
                this.setProductCardLoad(html);
              }
            })
            .catch((e) => {
              console.error(e);
            });
        };

        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: "0px 0px 400px 0px",
        }).observe(this);
      }

      setProductCardLoad(html) {
        const productCards = html.querySelector(".product-card");
        if (productCards) {
          this.classList.add("product-recommendations--loaded");
        } else {
          this.classList.add("f-hidden");

          let block = this.closest(".f-product-single__block");
          block && block.classList.add("f-hidden");
        }
      }
    }
  );
}
